var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.key != '')?_c('div',{staticClass:"pt-3"},[_c('vue-recaptcha',{attrs:{"sitekey":_vm.key,"loadRecaptchaScript":true},on:{"verify":_vm.onVerify}}),_vm._v(" "),(_vm.robot)?_vm._t("default"):_c('div',{staticClass:"captcha-disabled"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }